
const ExternalLink = ({children, ...props}) => {
    return (
        <a
            onClick={(event) => {
                event.stopPropagation();
            }}
            referrerPolicy='no-referrer'
            target='_blank'
            {...props}
        >
            {children}
        </a>
    );
};

export default ExternalLink;
